/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyBaseVo from './CompanyBaseVo';
import IdNameVo from './IdNameVo';




  /**
   * The JwStudentVo model module.
   * @module account_mgt/model/JwStudentVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>JwStudentVo</code>.
   * @alias module:account_mgt/model/JwStudentVo
   * @class
   */
  var exports = function() {
    var _this = this;


































  };

  /**
   * Constructs a <code>JwStudentVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/JwStudentVo} obj Optional instance to populate.
   * @return {module:account_mgt/model/JwStudentVo} The populated <code>JwStudentVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cxId')) {
        obj['cxId'] = ApiClient.convertToType(data['cxId'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'realname')) {
        obj['realname'] = ApiClient.convertToType(data['realname'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gender')) {
        obj['gender'] = ApiClient.convertToType(data['gender'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'birthday')) {
        obj['birthday'] = ApiClient.convertToType(data['birthday'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'entryGrade')) {
        obj['entryGrade'] = ApiClient.convertToType(data['entryGrade'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'grade')) {
        obj['grade'] = ApiClient.convertToType(data['grade'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwDeptId')) {
        obj['jwDeptId'] = ApiClient.convertToType(data['jwDeptId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'yxid')) {
        obj['yxid'] = ApiClient.convertToType(data['yxid'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwDeptName')) {
        obj['jwDeptName'] = ApiClient.convertToType(data['jwDeptName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwMajorId')) {
        obj['jwMajorId'] = ApiClient.convertToType(data['jwMajorId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'zyid')) {
        obj['zyid'] = ApiClient.convertToType(data['zyid'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwMajorName')) {
        obj['jwMajorName'] = ApiClient.convertToType(data['jwMajorName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwClazzId')) {
        obj['jwClazzId'] = ApiClient.convertToType(data['jwClazzId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bjid')) {
        obj['bjid'] = ApiClient.convertToType(data['bjid'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwClazzName')) {
        obj['jwClazzName'] = ApiClient.convertToType(data['jwClazzName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'semester')) {
        obj['semester'] = ApiClient.convertToType(data['semester'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduLevel')) {
        obj['eduLevel'] = ApiClient.convertToType(data['eduLevel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'schoolRollLabel')) {
        obj['schoolRollLabel'] = ApiClient.convertToType(data['schoolRollLabel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'inSchoolLabel')) {
        obj['inSchoolLabel'] = ApiClient.convertToType(data['inSchoolLabel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwStatus')) {
        obj['jwStatus'] = ApiClient.convertToType(data['jwStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwStatusLabel')) {
        obj['jwStatusLabel'] = ApiClient.convertToType(data['jwStatusLabel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'registStatusLabel')) {
        obj['registStatusLabel'] = ApiClient.convertToType(data['registStatusLabel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'arriveStatusLabel')) {
        obj['arriveStatusLabel'] = ApiClient.convertToType(data['arriveStatusLabel'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'nation')) {
        obj['nation'] = ApiClient.convertToType(data['nation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'updateTime')) {
        obj['updateTime'] = ApiClient.convertToType(data['updateTime'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'campus')) {
        obj['campus'] = IdNameVo.constructFromObject(data['campus']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'campanyId')) {
        obj['campanyId'] = CompanyBaseVo.constructFromObject(data['campanyId']);
      }
    }
    return obj;
  }

  /**
   * 学籍ID
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 超星ID
   * @member {String} cxId
   */
  exports.prototype['cxId'] = undefined;
  /**
   * 学号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 姓名
   * @member {String} realname
   */
  exports.prototype['realname'] = undefined;
  /**
   * 性别 0：未知、1：男、2：女
   * @member {Integer} gender
   */
  exports.prototype['gender'] = undefined;
  /**
   * 出生日期
   * @member {String} birthday
   */
  exports.prototype['birthday'] = undefined;
  /**
   * 身份证件号
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 入学年级
   * @member {String} entryGrade
   */
  exports.prototype['entryGrade'] = undefined;
  /**
   * 所在年级
   * @member {String} grade
   */
  exports.prototype['grade'] = undefined;
  /**
   * 教务院系ID
   * @member {Integer} jwDeptId
   */
  exports.prototype['jwDeptId'] = undefined;
  /**
   * 院系ID
   * @member {String} yxid
   */
  exports.prototype['yxid'] = undefined;
  /**
   * 院系名称
   * @member {String} jwDeptName
   */
  exports.prototype['jwDeptName'] = undefined;
  /**
   * 教务专业ID
   * @member {Integer} jwMajorId
   */
  exports.prototype['jwMajorId'] = undefined;
  /**
   * 专业ID
   * @member {String} zyid
   */
  exports.prototype['zyid'] = undefined;
  /**
   * 专业名称
   * @member {String} jwMajorName
   */
  exports.prototype['jwMajorName'] = undefined;
  /**
   * 教务班级ID
   * @member {Integer} jwClazzId
   */
  exports.prototype['jwClazzId'] = undefined;
  /**
   * 班级ID
   * @member {String} bjid
   */
  exports.prototype['bjid'] = undefined;
  /**
   * 班级名称
   * @member {String} jwClazzName
   */
  exports.prototype['jwClazzName'] = undefined;
  /**
   * 学制
   * @member {String} semester
   */
  exports.prototype['semester'] = undefined;
  /**
   * 培养层次
   * @member {String} eduLevel
   */
  exports.prototype['eduLevel'] = undefined;
  /**
   * 学籍状态
   * @member {String} schoolRollLabel
   */
  exports.prototype['schoolRollLabel'] = undefined;
  /**
   * 是否在校
   * @member {String} inSchoolLabel
   */
  exports.prototype['inSchoolLabel'] = undefined;
  /**
   * 学生当前状态
   * @member {Integer} jwStatus
   */
  exports.prototype['jwStatus'] = undefined;
  /**
   * 学生当前状态标签
   * @member {String} jwStatusLabel
   */
  exports.prototype['jwStatusLabel'] = undefined;
  /**
   * 注册状态
   * @member {String} registStatusLabel
   */
  exports.prototype['registStatusLabel'] = undefined;
  /**
   * 报到状态
   * @member {String} arriveStatusLabel
   */
  exports.prototype['arriveStatusLabel'] = undefined;
  /**
   * 民族
   * @member {String} nation
   */
  exports.prototype['nation'] = undefined;
  /**
   * 更新时间
   * @member {String} updateTime
   */
  exports.prototype['updateTime'] = undefined;
  /**
   * 状态 1：可用；0：禁用
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;
  /**
   * 校区
   * @member {module:account_mgt/model/IdNameVo} campus
   */
  exports.prototype['campus'] = undefined;
  /**
   * 学校
   * @member {module:account_mgt/model/CompanyBaseVo} campanyId
   */
  exports.prototype['campanyId'] = undefined;



  export default exports;
;


